import script from "./ActionsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ActionsComponent.vue?vue&type=style&index=0&id=5a6ec554&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6ec554"]])

export default __exports__